import { render, staticRenderFns } from "./verifikasi_ppbpemda.vue?vue&type=template&id=ef0bf7f6&scoped=true"
import script from "./verifikasi_ppbpemda.vue?vue&type=script&lang=js"
export * from "./verifikasi_ppbpemda.vue?vue&type=script&lang=js"
import style0 from "./verifikasi_ppbpemda.vue?vue&type=style&index=0&id=ef0bf7f6&prod&lang=scss"
import style1 from "./verifikasi_ppbpemda.vue?vue&type=style&index=1&id=ef0bf7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0bf7f6",
  null
  
)

export default component.exports